import { FC } from 'react';

import { Icon, IconProps } from '@purpur/library/icon';

import { RoundFilledIconWrapper } from './RoundFilledIcon.styles';

export const RoundFilledIcon: FC<IconProps> = ({ svg, size, className }) => (
    <RoundFilledIconWrapper className={className}>
        <Icon svg={svg} size={size} />
    </RoundFilledIconWrapper>
);
